import React from 'react';

import { SecondaryContextsReadyContextProvider } from './SecondaryContextsReadyContext';

const withSecondaryContextsReadyContext = (Component) => (props) => (
  <SecondaryContextsReadyContextProvider>
    <Component {...props} />
  </SecondaryContextsReadyContextProvider>
);

export {
  withSecondaryContextsReadyContext,
};
